<app-option-bar [type]="'GOPHER'"></app-option-bar>
<div class="gopher-wrapper gopher-list">
  <div class="container-fluid">
    <div class="content-wrapper">
      <!-- Menu Section -->
      <div class="inner-nav">
        <app-left-menu [type]="'GOPHER'"></app-left-menu>
      </div>

      <div class="inner-content collapsed">
        <!-- <h3>Attacks</h3> -->
        <div class="table-responsive">
          <table class="table table-condensed table-hover gopher-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Project</th>
                <th>Start time</th>
                <th>End time</th>
                <th>Target type</th>
                <th>Target host</th>
                <th>Arguments</th>
                <th>Status</th>
              </tr>
            </thead>
            <tr *ngIf="attackLists?.attacks && attackLists?.attacks.length === 0">
              <td colspan="5">No data found</td>
            </tr>
            <tr class="pointer" class="clickable" *ngFor="let attack of attackLists?.attacks"
              [routerLink]="[attack.id]">
              <td>{{ attack.type }}</td>
              <td>{{ attack.project.name }}</td>
              <td>{{ attack.startTime | localDate }}</td>
              <td>{{ attack.endTime | localDate }}</td>
              <td>{{ attack.gopherClient.server_type }}</td>
              <td>{{ attack.gopherClient.hostAddress }}</td>
              <td>
                <small *ngFor="let item of attack.args | keyvalue">
                  <small class="font-bold">{{ item.key }} : </small> {{ item.value }}
                </small>
              </td>
              <td>
                <span class="{{ attack.status }}">{{ attack.status }}</span>
                <img src="/assets/images/spin.svg" alt="Loading .." width="18px" *ngIf="!attack.isCompleted" />
              </td>
            </tr>
          </table>
        </div>
        <!-- Pagination Section -->

        <div class="row pagination-sec pt-3 pb-3">
          <div class="col-6">
            <div class="result-found-pagination">Total Results : {{ collectionSize || 0 }}</div>
          </div>
          <div class="col-1">
            <select class="form-control form-control-sm" (change)="onSizeChange(pageSize)" [(ngModel)]="pageSize">
              <option>15</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
          <div class="col-5">
            <ngb-pagination class="d-flex justify-content-end" [collectionSize]="collectionSize" [maxSize]="7"
              [pageSize]="pageSize" [(page)]="page" [boundaryLinks]="true" [rotate]="true"
              (pageChange)="onPageChange($event)"></ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>